<template>
    <div>
        <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='添加行业' }" v-has="'btn_add'"> 添加行业
        </a-button>
        <a-button class="top_btn" type="primary" @click="listOrder()" v-has="'btn_listorder'"> 排序</a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id" >
            <span slot="list_order" slot-scope="text, record">
        <a-input placeholder=" " v-model="record.list_order" class="inputs" size="small"/>
            </span>
<!--            <span slot="action" slot-scope="text, record">-->
<!--                <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>-->
<!--        <a @click="(record)=>{visibleForm = true; titleForm='修改行业'; editId=text.id ; }" v-has="'btn_edit'">编辑 <a-divider  type="vertical"/></a>-->

<!--          <a-popconfirm v-if="text.type!=1"-->
<!--                  title="此操作将永久删除, 是否继续?"-->
<!--                  ok-text="确定"-->
<!--                  cancel-text="取消"-->
<!--                  @confirm="confirm(record)"-->
<!--                  @cancel="()=>{}"-->
<!--          >-->
<!--   <a v-has="'btn_delete'">删除</a>-->
<!--  </a-popconfirm>-->
<!--      </span>-->
        </a-table>
        <IndustryForm :visible="visibleForm" :title="titleForm" :editId="editId"
                  @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>
    </div>

</template>

<script>
    import API from "./api";
    import IndustryForm from "./components/industryForm"
    import {changStatus, removeById,orderList} from "../../utils/utils"
    const columns = [
        {
            title: "排序",
            dataIndex: "list_order",
            ellipsis: true,
            key: "list_order",
            scopedSlots: {customRender: "list_order"}
        },
        {
            title: "ID",
            dataIndex: "id",
            ellipsis: true,
            key: "id"
        },
        {
            title: "名称",
            key: "mname_ch",
            dataIndex: "mname_ch",
        },
        // {
        //     title: "操作",
        //     key: "action",
        //     width: "200px",
        //     scopedSlots: {customRender: "action"}
        // }
    ];
    export default {
        name: 'Industry',
        data() {
            return {
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                data: [],
                columns,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/CustomerManagement/Industry"; //设置左侧导航2-2 active
        },
        components: {IndustryForm},
        methods: {
            listOrder() {
                let list_orders = []
                let sortListOrder = {id: "", list_order: ""}
                for (let i = 0; i < this.data.length; i++) {
                    sortListOrder.id = this.data[i].id
                    sortListOrder.list_order = this.data[i].list_order
                    list_orders.push(sortListOrder)
                    sortListOrder = {}
                }
                orderList(API.industry.LIST_ORDER, list_orders).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },

            getList(page) {
                API.industry.GET_INDUSTRY(page||1).then(res => {
                    this.data = res.data.data
                    this.loading = false
                })
            },
            confirm(row) {
                removeById( API.industry.DELE, [row.id]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
</style>
